"use client";

import React from "react";
import Image from "next/image";

import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";

import { CTAButton } from "@/shadcn/ui/button";

import { PageChallengeSchema } from "@/sanity/pages/PageChallengeTemplate";

import dots from "@/public/home-v2/dots.svg";
import ChipSerif from "@/components/global/ui/ChipSerif";
import ProgressItems from "./ProgressItems";

export default function Process({ data }: { data: PageChallengeSchema }) {
  return (
    <section className="bg-[#FBFBF9]">
      <div className="w-[min(176.5rem,100%)] mx-auto rounded-[2rem] lg:rounded-[5rem] flex flex-col items-center pt-[7rem] pb-[4rem] lg:py-[12.5rem] px-[2.5rem] sm:px-[5rem] relative overflow-clip">
        <div className="w-[min(136rem,100%)] flex flex-col lg:flex-row items-center lg:items-start lg:justify-between">
          <div className="w-[min(62rem,100%)] flex flex-col items-center lg:items-start">
            <ChipSerif text={data?.processChip} className="text-white" />

            {data?.processTitle && (
              <div className="richtext lg:richtext-start prose-h2:text-white prose-p:text-white/70 mb-[4rem]">
                <PortableText
                  value={data.processTitle}
                  components={richTextComponent}
                />
              </div>
            )}

            <CTAButton
              className="mx-0 w-auto hidden lg:flex"
              data={data?.processCTA}
            />
          </div>

          <div className="w-[min(67.625rem,100%)]">
            <ProgressItems items={data?.processCards} />
          </div>

          <CTAButton
            className="mx-0 lg:hidden mt-[4rem] w-full"
            data={data?.processCTA}
          />
        </div>
      </div>
    </section>
  );
}
